import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["handleShareLink", "role", "venueName", "fromDate", "toDate", "isShareable", "disabled", "disableShareLink", "showTooltip"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { LinkIcon } from '@heroicons/react/24/outline';
import { Button, Tooltip } from '@restworld/ui-ds-base';
import { Switch } from '../../../design-system';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-request-card__CardContainer",
  componentId: "sc-1la2esh-0"
})({
  "display": "inline-flex",
  "height": "fit-content",
  "width": "100%",
  "maxWidth": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "outlineStyle": "solid",
  "outlineWidth": "1px",
  "outlineOffset": "-1px",
  "outlineColor": "#dedee1"
});

var TopRow = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-request-card__TopRow",
  componentId: "sc-1la2esh-1"
})({
  "display": "inline-flex",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem",
  "alignSelf": "stretch"
});

var InfoCol = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-request-card__InfoCol",
  componentId: "sc-1la2esh-2"
})({
  "display": "inline-flex",
  "width": "78%",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.25rem"
});

var RoleText = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-request-card__RoleText",
  componentId: "sc-1la2esh-3"
})({
  "justifyContent": "flex-start",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var VenueText = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-request-card__VenueText",
  componentId: "sc-1la2esh-4"
})({
  "width": "100%",
  "justifyContent": "flex-start",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var DateText = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-request-card__DateText",
  componentId: "sc-1la2esh-5"
})({
  "justifyContent": "flex-start",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

export var ReferenceRequestCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var handleShareLink = _ref.handleShareLink,
      role = _ref.role,
      venueName = _ref.venueName,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      isShareable = _ref.isShareable,
      disabled = _ref.disabled,
      disableShareLink = _ref.disableShareLink,
      showTooltip = _ref.showTooltip,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation('worker-references-page'),
      t = _useTranslation.t;

  var _useState = useState(false),
      checked = _useState[0],
      setChecked = _useState[1];

  return /*#__PURE__*/_jsxs(CardContainer, {
    ref: ref,
    children: [/*#__PURE__*/_jsxs(TopRow, {
      children: [/*#__PURE__*/_jsxs(InfoCol, {
        children: [/*#__PURE__*/_jsx(RoleText, {
          children: t('reference_request_card.role_at', {
            role: role
          })
        }), /*#__PURE__*/_jsx(VenueText, {
          children: venueName
        })]
      }), /*#__PURE__*/_jsx(Switch, _objectSpread({
        disabled: disabled,
        size: "sm",
        checked: checked,
        onChange: setChecked
      }, rest))]
    }), /*#__PURE__*/_jsx(DateText, {
      children: t('reference_request_card.date_title', {
        fromDate: fromDate,
        toDate: toDate
      })
    }), isShareable && /*#__PURE__*/_jsx(Tooltip, {
      hidden: !showTooltip,
      content: t('reference_request_card.actions.tooltip'),
      arrow: true,
      wrapperStyles: {
        "width": "100%"
      },
      children: /*#__PURE__*/_jsx(Button, {
        disabled: disableShareLink,
        fullwidth: true,
        variant: "secondary-restworld",
        StartIcon: LinkIcon,
        onClick: handleShareLink,
        children: t('reference_request_card.actions.primary')
      })
    })]
  });
});
export default ReferenceRequestCard;